import { createSelector } from 'reselect';
import * as R from 'ramda';
import localeKeys from './../../locales/keys';
import { i18n, SelectHelper } from 'invision-core';
import { RETURN_AUTO_ORDERS_FILTER_ID, RETURN_MIGRATED_ORDERS_FILTER_ID } from './../actions/order.history.filter.actions';
var recoverableUIStateSelector = function recoverableUIStateSelector(state) {
  return state.customercare.recoverableUiState.orderHistory;
};
export var selectedTypeFilterSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.typeFilter;
});
export var selectedStatusFilterSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.statusFilter;
});
export var pageNumberSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.pageNumber;
});
export var SelectedPageSizePreferenceSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.pageSizePreference;
});
export var startDateSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.startDate;
});
export var endDateSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.endDate;
});
export var selectedKindFilterSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.kindFilter;
});
var defaultOrderKindsFiltersSelector = createSelector(function () {
  return [{
    id: RETURN_AUTO_ORDERS_FILTER_ID,
    value: RETURN_AUTO_ORDERS_FILTER_ID,
    text: i18n.translate(localeKeys.ORDER_HISTORY.FILTERS.RETURN_AUTO_ORDERS_OPTION)
  }, {
    id: RETURN_MIGRATED_ORDERS_FILTER_ID,
    value: RETURN_MIGRATED_ORDERS_FILTER_ID,
    text: i18n.translate(localeKeys.ORDER_HISTORY.FILTERS.RETURN_MIGRATED_ORDERS_OPTION)
  }];
});
export var orderKindsFiltersSelector = createSelector([defaultOrderKindsFiltersSelector, selectedKindFilterSelector], function (defaultOrderKinds, selectedKindFilters) {
  return R.sortBy(R.prop('text'))(SelectHelper.mapCodesWithSelectedCodes(defaultOrderKinds, selectedKindFilters));
});
export var autoOrdersFilterSelector = createSelector([orderKindsFiltersSelector], function (orderKindsFilters) {
  return orderKindsFilters.find(function (orderKind) {
    return orderKind.id === RETURN_AUTO_ORDERS_FILTER_ID;
  }) || null;
});
export var migratedOrdersFilterSelector = createSelector([orderKindsFiltersSelector], function (orderKindsFilters) {
  return orderKindsFilters.find(function (orderKind) {
    return orderKind.id === RETURN_MIGRATED_ORDERS_FILTER_ID;
  }) || null;
});